var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.mode === "DESIGN"
        ? _c(
            "div",
            { staticClass: "disabled-box max-width" },
            [
              _c("el-select", {
                staticClass: "select-u",
                attrs: { placeholder: _vm.cityPlaceholder, size: "small" },
                model: {
                  value: _vm._value,
                  callback: function ($$v) {
                    _vm._value = $$v
                  },
                  expression: "_value",
                },
              }),
              _vm.inputType === "detail"
                ? _c("el-input", {
                    staticClass: "address",
                    attrs: {
                      size: "small",
                      placeholder: "请输入详细地址",
                      maxlength: 20,
                      "show-word-limit": "",
                      rows: 2,
                      type: "textarea",
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : [
            !_vm.readerMode || _vm.perm === "E"
              ? _c(
                  "div",
                  [
                    _c("el-cascader", {
                      staticClass: "select-u",
                      attrs: {
                        placeholder: _vm.cityPlaceholder,
                        size: "small",
                        props: _vm.cityProps,
                        options: _vm.selectList(_vm.inputType),
                        disabled: _vm.perm === "R",
                      },
                      on: { change: _vm.change },
                      model: {
                        value: _vm._value.value,
                        callback: function ($$v) {
                          _vm.$set(_vm._value, "value", $$v)
                        },
                        expression: "_value.value",
                      },
                    }),
                    _vm.inputType === "detail"
                      ? _c("el-input", {
                          staticClass: "address",
                          attrs: {
                            disabled: _vm.perm === "R",
                            size: "small",
                            placeholder: "请输入详细地址",
                            maxlength: 20,
                            "show-word-limit": "",
                            rows: 2,
                            type: "textarea",
                          },
                          on: { change: _vm.change },
                          model: {
                            value: _vm._value.detail,
                            callback: function ($$v) {
                              _vm.$set(_vm._value, "detail", $$v)
                            },
                            expression: "_value.detail",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _c("div", { staticClass: "form-item-text" }, [
                  _vm._v(" " + _vm._s(_vm.valueText) + " "),
                ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }